import { ref } from 'vue'

const membershipId = ref<number>()
export const getEducationMembershipId = () => membershipId.value
export const setEducationMembershipId = (value?: number) => {
  membershipId.value = value
}
